import { defineMessages } from 'react-intl';

export const messages: {
	filterIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	filterIconLabel: {
		id: 'filter',
		defaultMessage: 'Filter icon',
		description:
			'Accessible label for the filter icon shown inside each filter option row in the Quick Find query filters panel, used by screen readers to identify the icon.',
	},
});
